<template>
  <el-card class="box-card" v-loading="myLoding">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">模型列表</span>
      <div class="head-text">
        <el-input placeholder="请输入关键字" class="search-input width200" v-model="modelQuery"></el-input>
        <el-button icon="el-icon-search" @click="modelList"></el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table v-loading="loading" :data="modelList1" height="72vh" class="width100">
      <el-table-column align="center" type="selection" width="55"></el-table-column>
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column align="center" prop="mode02" label="文件名称"></el-table-column>
      <el-table-column align="center" prop="mode10" label="文件大小">
        <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
      </el-table-column>
      <el-table-column align="center" prop="mode04" label="上传文件大小">
        <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
      </el-table-column>
      <el-table-column align="center" prop="mode05" label="版本备注"></el-table-column>
      <el-table-column align="center" prop="mode06" label="联系人"></el-table-column>
      <el-table-column align="center" prop="mode07" label="邮箱"></el-table-column>
      <el-table-column align="center" prop="mode08" label="电话"></el-table-column>
      <!-- <el-table-column align="center" prop="versionNum" label="版本数量" sortable></el-table-column> -->
      <el-table-column align="center" prop="cname" label="所属公司"></el-table-column>
      <el-table-column align="center" prop="mode11" label="更新时间"></el-table-column>
      <el-table-column align="center" label="操作" width="225">
        <template slot-scope="scope">
          <!-- <el-button plain class="mar-top3" size="small" @click="banbenShow(scope.row)" type="primary">版本</el-button> -->
          <el-button plain class="mar-top3" size="small" @click="guishuShow(scope.row)" type="primary">归属</el-button>
          <!-- <el-button plain class="mar-top3" size="small" @click="deleteModel(scope.row)" type="primary">删除</el-button> -->
          <el-button plain class="mar-top3" size="small" @click="copyModelShow(scope.row)" type="primary">复制</el-button>
          <!-- <el-button plain class="mar-top3" size="small" @click="downloadNew(scope.row)" type="primary">下载</el-button> -->
          <el-button plain class="mar-top3" size="small" @click="modelView(scope.row)" type="primary">浏览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination align="center" class="mar-top20" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="pageIndex" :page-size="pageSize"
        :page-sizes="[100, 50, 10]" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <!-- 版本 -->
    <el-dialog :close-on-click-modal="false" title="版本" :visible.sync="banben" width="60%">
      <el-table v-loading="loading" :data="modelList2" max class="width100" height="500px">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column align="center" prop="mode02" label="文件名称"></el-table-column>
        <el-table-column align="center" prop="mode10" label="文件大小">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode04" label="上传文件大小">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode05" label="版本备注"></el-table-column>
        <el-table-column align="center" prop="mode06" label="联系人"></el-table-column>
        <el-table-column align="center" prop="mode07" label="邮箱"></el-table-column>
        <el-table-column align="center" prop="mode08" label="电话"></el-table-column>
        <el-table-column align="center" prop="mode03" label="备注"></el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="small" @click="modelVersionView(scope.row)" type="primary">浏览</el-button>
            <el-button size="small" @click="download(scope.row)" type="primary">下载</el-button>
            <el-button size="small" @click="DelModelfileVersion(scope.row)" type="primary">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 归属 -->
    <el-dialog :close-on-click-modal="false" title="所属项目" :visible.sync="guishu" width="30%">
      <el-table :data="projectList">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column align="center" prop="proj03" label="项目名称"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 模型复制 -->
    <el-dialog :close-on-click-modal="false" title="模型复制" :visible.sync="copyModelVisible" width="30%">
      <el-card class="box-card height300">
        <el-form class="mar-left80" ref="copyModelList" :model="copyModelList" label-width="80px">
          <el-form-item label="重新命名">
            <el-input class="width65" v-model="copyModelList.name"></el-input>
          </el-form-item>
          <el-form-item label="选择企业">
            <el-select @change="changeCompany" filterable v-model="copyModelList.cid" placeholder="请选择">
              <el-option v-for="item in companyList" :key="item.comp01" :label="item.comp02"
                :value="item.comp01"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择项目">
            <el-select v-model="copyModelList.xid" filterable placeholder="请选择">
              <el-option v-for="item in projectList" :key="item.proj01" :label="item.proj03"
                :value="item.proj01"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="12" class="center">
            <el-button class="width50" size="small" type="primary" @click="CopyModel">确认</el-button>
          </el-col>
          <el-col :span="12" class="center">
            <el-button class="width50" size="small" type="danger" @click="copyModelVisible = false">取消</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetModelList,
  GetModelLinkProjectList,
  GetModelVersionsList,
  DownModel,
  DelModelFile,
  CopyModel,
  DelModelfileVersion,
  GetCompanyList,
  GetCompanyProjectList,
} from "@/setAxios";
export default {
  data() {
    return {
      myLoding: false,
      guishu: false,
      banben: false,
      copyModelVisible: false,
      copyModelList: {
        name: "",
        cid: "",
        xid: "",
        mid: "",
      },
      companyList: [],
      projectList: [],
      modelQuery: "",
      loading: false,
      modelList1: [],
      modelList2: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      mode01: "",
    };
  },
  created() {
    this.modelList();
  },
  methods: {
    // 浏览模型
    modelView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    // 复制
    async copyModelShow(data) {
      this.copyModelVisible = true;
      this.copyModelList.mid = data.mode01;
      let params = {
        seachword: "",
        pageIndex: 1,
        pageSize: 1000000,
      };
      let res = await GetCompanyList({ params });
      this.companyList = res.Data.list;
    },
    async CopyModel() {
      let res = await CopyModel(this.copyModelList);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "复制成功",
        });
        this.copyModelVisible = false;
        this.modelList();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    async changeCompany(data) {
      let params = {
        seachword: "",
        bid: "null",
        pageIndex: 1,
        pageSize: 10000000,
        qid: this.copyModelList.cid,
      };
      let res = await GetCompanyProjectList({ params });
      this.projectList = res.Data.lsit;
    },
    // 删除
    deleteModel(row) {
      this.$confirm("此操作将永久删除该模型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.mode01,
        };
        DelModelFile(params).then((res) => {
          if (res.Code === 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.modelList();
          }
        });
      });
    },
    //历史版本浏览模型
    modelVersionView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    // 删除历史Model
    DelModelfileVersion(row) {
      this.$confirm("此操作将永久删除该模型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.mode01,
        };
        DelModelfileVersion(params).then((res) => {
          if (res.Code === 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.GetModelVersionsList();
          }
        });
      });
    },
    async download(row) {
      this.myLoding = true;
      let params = {
        id: row.mode01,
      };
      let res = await DownModel(params);
      this.myLoding = false;
      if (res.Code == 1) {
        let httpUrl = this.$store.state.baseUrl + res.Data;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = httpUrl;
        document.body.appendChild(link);
        link.click();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    async downloadNew(row) {
      this.myLoding = true;
      let params = {
        id: row.mode01,
      };
      let res = await DownModel(params);
      this.myLoding = false;
      if (res.Code == 1) {
        let httpUrl = this.$store.state.baseUrl + res.Data;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = httpUrl;
        document.body.appendChild(link);
        link.click();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    async guishuShow(row) {
      let params = { mid: row.mode01 };
      let res = await GetModelLinkProjectList(params);
      this.projectList = res.Data;
      this.guishu = true;
    },
    async banbenShow(row) {
      this.mode01 = row.mode15;
      this.GetModelVersionsList();
      this.banben = true;
    },
    async GetModelVersionsList() {
      let params = { mid: this.mode01 };
      this.loading = true;
      let res = await GetModelVersionsList(params);
      this.loading = false;
      this.modelList2 = res.Data;
    },
    // 显示模型管理器页面
    modelList() {
      this.loading = true;
      let params = {
        seachword: this.modelQuery,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetModelList({ params }).then((res) => {
        this.loading = false;
        this.modelList1 = res.Data.list;
        this.total = res.Data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.modelList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.modelList();
    },
  },
};
</script>

<style lang="less">
.page {
  height: 80px;
  margin-top: 10px;
}
</style>

<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.width200 {
  width: 200px;
}

.width100 {
  width: 100%;
}

.mar-top3 {
  margin-top: 3px;
}

.mar-left10 {
  margin-left: 10px;
}

.mar-top20 {
  margin-top: 20px;
}

.height300 {
  height: 300px;
}

.mar-left80 {
  margin-left: 80px;
}

.width65 {
  width: 65%;
}

.width50 {
  width: 50%;
}

.center {
  align-content: center;
}
</style>
